import {
  CheckOutlined,
  ErrorOutline,
  HistoryToggleOffOutlined,
  InfoOutlined,
  WarningAmberRounded,
} from '@mui/icons-material'
import { Chip, Tooltip, Typography } from '@mui/material'

/**
 *
 * @param {string} status
 * @returns JSX.Element
 */
export function renderChip(status) {
  if (!status || typeof status !== 'string')
    return <Chip size="medium" variant="contained" sx={{ bgcolor: '#668E9B', color: '#FFF' }} label="Indisponível" />

  switch (status.toLocaleLowerCase()) {
    case 'active':
      return <Chip size="medium" variant="contained" sx={{ bgcolor: '#A0D690' }} label="Ativa" />
    case 'paused':
      return (
        <Chip 
          size="medium" 
          variant="contained" 
          sx={{ bgcolor: '#FEF5E7', color: '#F7A723', px: '.5rem' }} 
          label="Pausado"
          clickable={false}
          deleteIcon={
            <WarningAmberRounded
              style={{
                color: '#F17C0C',
                cursor: 'default',
              }}
            />
          }
          onDelete={() => {}}
        />
      )
    case 'archived':
      return <Chip size="medium" variant="contained" sx={{ bgcolor: '#E0E0E0', color: '#60BB46' }} label="Arquivado" />
    case 'approved':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EEF8EB', color: '#60BB46', px: '.5rem' }}
          label="Aprovado"
        />
      )
    case 'connected':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EEF8EB', color: '#60BB46', px: '.5rem' }}
          label="Conectado"
        />
      )
    case 'banned':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#FDEAE9', color: '#EF3E39', px: '.5rem' }}
          label="Banido"
          deleteIcon={
            <ErrorOutline
              style={{
                color: '#EF3E39',
                cursor: 'default',
              }}
            />
          }
          clickable={false}
          onDelete={() => {}}
        />
      )
    case 'migrated':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EDF7FE', color: '#2196F3', px: '.5rem' }}
          label="Migrado"
        />
      )
    case 'flagged':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.4rem', bgcolor: '#FEF5E7', color: '#F7A723', px: '.5rem' }}
          label="Restrito [1]"
          clickable={false}
          deleteIcon={
            <WarningAmberRounded
              style={{
                color: '#F7A723',
                cursor: 'default',
              }}
            />
          }
          onDelete={() => {}}
        />
      )
    case 'rate_limited':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.4rem', bgcolor: '#FEF5E7', color: '#F7A723', px: '.5rem' }}
          label="Restrito [2]"
          clickable={false}
          deleteIcon={
            <WarningAmberRounded
              style={{
                color: '#F7A723',
                cursor: 'default',
              }}
            />
          }
          onDelete={() => {}}
        />
      )
    case 'limitexceeded':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.4rem', bgcolor: '#FEF5E7', color: '#F7A723', px: '.5rem' }}
          label="Limite excedido"
          clickable={false}
          deleteIcon={
            <WarningAmberRounded
              style={{
                color: '#F17C0C',
                cursor: 'default',
              }}
            />
          }
          onDelete={() => {}}
        />
      )
    case 'restricted':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.4rem', bgcolor: '#FEF5E7', color: '#F7A723', px: '.5rem' }}
          label="Restrito [3]"
          clickable={false}
          deleteIcon={
            <WarningAmberRounded
              style={{
                color: '#F7A723',
                cursor: 'default',
              }}
            />
          }
          onDelete={() => {}}
        />
      )
    case 'pending':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.4rem', bgcolor: '#FEF5E7', color: '#F7A723', px: '.5rem' }}
          label="Pendente"
          clickable={false}
          deleteIcon={
            <WarningAmberRounded
              style={{
                color: '#F7A723',
                cursor: 'default',
              }}
            />
          }
          onDelete={() => {}}
        />
      )
    case 'awaiting':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.4rem', bgcolor: '#FEF5E7', color: '#F7A723', px: '.5rem' }}
          label="Aguardando"
          clickable={false}
          deleteIcon={
            <WarningAmberRounded
              style={{
                color: '#F7A723',
                cursor: 'default',
              }}
            />
          }
          onDelete={() => {}}
        />
      )
    case 'inprocess':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EDF7FE', color: '#2196F3', px: '.5rem' }}
          label="Processando"
        />
      )
    case 'inreview':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EDF7FE', color: '#2196F3', px: '.5rem' }}
          label="Em análise"
        />
      )
    case 'inappeal':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#F2E7FE', color: '#7423F7', px: '.5rem' }}
          label="Em apelação"
        />
      )
    case 'processed':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EEF8EB', color: '#60BB46', px: '.5rem' }}
          label="Disponível"
        />
      )
    case 'error':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.3rem', bgcolor: '#FDEAE9', color: '#EF3E39', px: '.5rem' }}
          label="Erro"
          deleteIcon={
            <ErrorOutline
              style={{
                color: '#EF3E39',
                cursor: 'default',
              }}
            />
          }
          clickable={false}
          onDelete={() => {}}
        />
      )
    case 'rejected':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ gap: '.3rem', bgcolor: '#FDEAE9', color: '#EF3E39', px: '.5rem' }}
          label="Rejeitado"
          deleteIcon={
            <ErrorOutline
              style={{
                color: '#EF3E39',
                cursor: 'default',
              }}
            />
          }
          clickable={false}
          onDelete={() => {}}
        />
      )
    case 'unverified':
      return (
        <Chip size="medium" variant="contained" sx={{ bgcolor: '#F2E7FE', color: '#7423F7' }} label="Não verificado" />
      )
    case 'expired':
      return (
        <Chip size="medium" variant="contained" sx={{ bgcolor: '#EEE', color: '#666', px: '.5rem' }} label="Expirado" />
      )
    case 'deleted':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#9E9E9E', color: '#FFF', px: '.5rem' }}
          label="Deletado"
        />
      )
    case 'disconnected':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EEE', color: '#666', px: '.5rem' }}
          label="Desconectado"
        />
      )
    case 'disabled':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EEE', color: '#666', px: '.5rem' }}
          label="Desabilitado"
        />
      )
    case 'none':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EEE', color: '#666', px: '.5rem' }}
          label="Indisponível"
        />
      )
    case 'unknown':
      return (
        <Chip
          size="medium"
          variant="contained"
          sx={{ bgcolor: '#EEE', color: '#666', px: '.5rem' }}
          label="Desconhecido"
        />
      )
    default:
      return <Chip size="medium" variant="contained" sx={{ bgcolor: '#668E9B', color: '#FFF' }} label="Desativada" />
  }
}

/**
 *
 * @param {string} quality
 * @returns JSX.Element
 */
export function renderQuality(quality) {
  if (!quality || typeof quality !== 'string') {
    return (
      <Typography
        sx={{
          fontSize: '.8rem',
          display: 'flex',
          alignItems: 'center',
          gap: '.5rem',
        }}
      >
        Indisponível
      </Typography>
    )
  }
  switch (quality.toLocaleLowerCase()) {
    case 'green':
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect width="16" height="16" rx="8" fill="#EEF8EB" />
            <path
              d="M2.66669 8.00002L3.60669 8.94002L7.33335 5.22002V13.3334H8.66669V5.22002L12.3867 8.94669L13.3334 8.00002L8.00002 2.66669L2.66669 8.00002Z"
              fill="#60BB46"
            />
          </svg>
          Alta
        </Typography>
      )
    case 'yellow':
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12.6666 8.66668H3.33331V7.33334H12.6666V8.66668Z" fill="#F7A723" />
          </svg>
          Média
        </Typography>
      )
    case 'red':
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect width="16" height="16" rx="8" fill="#FDEAE9" />
            <path
              d="M13.3334 7.99999L12.3934 7.05999L8.66669 10.78V2.66666H7.33335V10.78L3.61335 7.05332L2.66669 7.99999L8.00002 13.3333L13.3334 7.99999Z"
              fill="#EF3E39"
            />
          </svg>
          Baixa
        </Typography>
      )
    case 'ineligible':
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          <InfoOutlined color="error" fontSize="small" />
          Não elegível
        </Typography>
      )
    case 'eligible':
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          <InfoOutlined color="success" />
          Elegível
        </Typography>
      )
    case 'onboarded':
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          <CheckOutlined
            fontSize="small"
            sx={{
              color: '#60BB46',
            }}
          />
          Concluída
        </Typography>
      )
    case 'awaiting':
      return (
        <Tooltip title="A integração está sendo processada pela Meta.">
          <Typography
            sx={{
              fontSize: '.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '.5rem',
              cursor: 'pointer',
            }}
          >
            <HistoryToggleOffOutlined fontSize="small" sx={{ color: '#F7A723' }} />
            Aguardando
          </Typography>
        </Tooltip>
      )
    case 'unknown':
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          Desconhecido
        </Typography>
      )
    default:
      return (
        <Typography
          sx={{
            fontSize: '.8rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
          }}
        >
          Indisponível
        </Typography>
      )
  }
}
